/**
 * CLP Category Slider — vanilla JS
 * Handles touch-swipe + prev/next button navigation for .clp-slider__track
 */
(function () {
  'use strict';

  class ClpSlider extends HTMLElement {
    connectedCallback() {
      this._track = this.querySelector('.clp-slider__track');
      this._btnPrev = this.querySelector('.clp-slider__btn--prev');
      this._btnNext = this.querySelector('.clp-slider__btn--next');

      if (!this._track) return;

      this._bindButtons();
      this._bindTouch();
      this._updateButtons();

      this._track.addEventListener('scroll', () => this._updateButtons(), { passive: true });
    }

    _scrollAmount() {
      // Scroll by ~2 cards (first card width + gap)
      const card = this._track.querySelector('.clp-slider__item');
      if (!card) return 260;
      const style = getComputedStyle(this._track);
      const gap = parseFloat(style.gap) || 0;
      return (card.offsetWidth + gap) * 2;
    }

    _bindButtons() {
      if (this._btnPrev) {
        this._btnPrev.addEventListener('click', () => {
          this._track.scrollBy({ left: -this._scrollAmount(), behavior: 'smooth' });
        });
      }
      if (this._btnNext) {
        this._btnNext.addEventListener('click', () => {
          this._track.scrollBy({ left: this._scrollAmount(), behavior: 'smooth' });
        });
      }
    }

    _bindTouch() {
      let startX = 0;
      let startScroll = 0;
      let isDragging = false;

      this._track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startScroll = this._track.scrollLeft;
        isDragging = true;
      }, { passive: true });

      this._track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const dx = startX - e.touches[0].clientX;
        this._track.scrollLeft = startScroll + dx;
      }, { passive: true });

      this._track.addEventListener('touchend', () => { isDragging = false; });

      // Mouse drag for desktop
      this._track.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        startScroll = this._track.scrollLeft;
        isDragging = true;
        this._track.style.cursor = 'grabbing';
        this._track.style.userSelect = 'none';
      });
      this._track.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const dx = startX - e.clientX;
        this._track.scrollLeft = startScroll + dx;
      });
      const stopDrag = () => {
        isDragging = false;
        this._track.style.cursor = '';
        this._track.style.userSelect = '';
      };
      this._track.addEventListener('mouseup', stopDrag);
      this._track.addEventListener('mouseleave', stopDrag);
    }

    _updateButtons() {
      const track = this._track;
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

      if (this._btnPrev) this._btnPrev.toggleAttribute('disabled', atStart);
      if (this._btnNext) this._btnNext.toggleAttribute('disabled', atEnd);
    }
  }

  if (!customElements.get('clp-slider')) {
    customElements.define('clp-slider', ClpSlider);
  }
})();
